import script from "./CVForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CVForm.vue?vue&type=script&setup=true&lang=js"

import "./CVForm.vue?vue&type=style&index=0&id=762e10ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762e10ec"]])

export default __exports__